const UNSAFE_PATH_PATTERN = /(\.\.|\/|\\|%(?:25)*(?:2e|2f|5c))/i
const SAFE_ROUTE_PATTERN = /^[A-Za-z0-9._-]+$/
const SAFE_PATH_SEGMENT_PATTERN = /^[A-Za-z0-9._~-]+$/

export const isUnsafePathValue = value => {
  const raw = String(value ?? '').trim()
  return raw !== '' && UNSAFE_PATH_PATTERN.test(raw)
}

export const toSafePathSegment = value => {
  const raw = String(value ?? '').trim()

  if (!raw) {
    throw new Error('Unsafe path segment:')
  }

  if (isUnsafePathValue(raw) || !SAFE_PATH_SEGMENT_PATTERN.test(raw)) {
    throw new Error(`Unsafe path segment: ${raw}`)
  }

  return encodeURIComponent(raw)
}

export const toSafeRouteParam = value => {
  const raw = String(value ?? '').trim()

  if (!raw || UNSAFE_PATH_PATTERN.test(raw) || !SAFE_ROUTE_PATTERN.test(raw)) {
    return ''
  }

  return encodeURIComponent(raw)
}

export const toSafeQueryString = queryParams => {
  if (!queryParams) {
    return ''
  }

  const source =
    typeof queryParams === 'string'
      ? queryParams.replace(/^[?&]+/, '')
      : Object.entries(queryParams).reduce((acc, [key, value]) => {
          if (value === undefined || value === null) {
            return acc
          }

          acc.append(String(key), String(value))
          return acc
        }, new URLSearchParams())

  const params = new URLSearchParams(typeof source === 'string' ? source : source.toString())

  if ([...params.keys()].some(key => !key)) {
    throw new Error('Unsafe query parameter:')
  }

  return params.toString()
}

export const sanitizeSearchQuery = searchQuery => {
  const raw = String(searchQuery ?? '').trim()

  if (!raw) {
    return ''
  }

  if (UNSAFE_PATH_PATTERN.test(raw)) {
    throw new Error(`Unsafe search query: ${raw}`)
  }

  return raw
}
